export const STOPPED_TYPING_EVENT_TYPE = 'stopped-typing';
export const STARTED_TYPING_EVENT_TYPE = 'started-typing';
export const STOPPER_TYPED_EVENT_TYPE = 'stopper-typed';
